export const MODAL_TITLE_TEXT = 'To reset your password, enter your Xplorie email address!'
